import parseUri from './parseURI'
import qs from 'query-string'
import selectn from 'selectn'

/**
 * [translateURI helper function to translate a URL]
 * @param  {Object}  edition   edition data
 * @param  {Object}  req       request object
 * @param  {Boolean} localized localize to the current edition language
 * @return {Object}            return translated url
 */
export function translateURI(edition={}, req={}, localized=true) {

  //console.log('req.url => ', req.url)

  const url = (req.url) ? req.url : ''

  let translatedUrlObj = { url : '' }

  if(url) {

    const pathObj = parseUri(url)

    const translatedPath = translatePath(edition, pathObj.path, localized)
    const queryObject = translateQueryKey(edition, pathObj.queryKey, localized)

    let queryString = qs.stringify( queryObject )
    queryString = queryString ? ('?' + queryString) : ''


    translatedUrlObj = { url: (translatedPath + queryString) }

  }

  //console.log('translated url: ==>', translatedUrlObj.url,'\n')

  return translatedUrlObj

}
/**
 * [translatePath Translates a relative path to the local edition language]
 * @param  {Object}  edition   edition data
 * @param  {String}  path      relative path to be translated
 * @param  {Boolean} localized localize to the current edition language
 * @return {String}            return translated path
 */
export function translatePath(edition, path='', localized=true) {

  const pathOffset = '/'
  let newPathArr = [ '' ]
  let newPathArrString = ''
  const pathSegments = selectn('uriRewrites.pathSegments', edition) || {}

  if(path) {
    //split path based on / and translate
    let pathArr = path.split('/') || []
    let pathArrLen = pathArr.length

    for(let i=0; i < pathArrLen; i++) {
      let item = pathArr[i]
      if(item) {
        let value = ''
        if(localized) {
          value = pathSegments[item] || item
        }else{
          let objKeys = Object.keys(pathSegments) || []
          let objKeysLen = objKeys.length
          for(let j=0; j < objKeysLen; j++) {
            if(pathSegments[objKeys[j]] === item) {
              value = objKeys[j]
              break
            }else{
              value = item
            }
          }
        }
        if(value) {
          newPathArr.push(value)
        }
      }
    }
    newPathArrString = newPathArr.join(pathOffset)
  }
  if(!newPathArrString) {
    return path
  }

  return newPathArrString

}

/**
 * [translateQueryKey Translates queryKey object from location]
 * @param  {Object}  edition   edition data
 * @param  {Object}  queryKey  queryKey object from location
 * @param  {Boolean} localized localize to the current edition language
 * @return {Object}            translated queryKey
 */
export function translateQueryKey(edition, queryKey={}, localized=true) {

  let newQueryKey = {}
  let newQueryKeyLen = {}
  const paramKeys = selectn('uriRewrites.paramKeys', edition) || {}
  const paramValues = selectn('uriRewrites.paramValues', edition) || {}

  Object.keys(queryKey).map((item) => {
    if(item) {
      let value = queryKey[item]
      let name = ''
      if(localized) {
        name = paramKeys[item] || item
      }else{
        let objKeys = Object.keys(paramKeys) || []
        let objKeysLen = objKeys.length
        for(var j=0; j < objKeysLen; j++) {
          if(paramKeys[objKeys[j]] === item) {
            name = objKeys[j]
            break
          }else{
            name = item
          }
        }
      }
      if(name) {
        newQueryKey[name] = translateValue(value, paramValues, localized)
      }
    }
  })
  newQueryKeyLen = Object.keys(newQueryKey).length || 0
  if(newQueryKeyLen === 0) {
    return queryKey
  }
  return newQueryKey

}

/**
 * [translateValue translates value of key value pair in queryKey using pathSegments]
 * @param  {String}  value       Value of particular key in key-value
 * @param  {Object}  paramValues paramValues in edition config
 * @param  {Boolean} localized   localize to the current edition language
 * @return {String}              Translated value
 */
export function translateValue(value='', paramValues={}, localized=true) {
  let newValue = ''

  if(localized) {
    newValue = paramValues[value] || value
  }else{
    let objKeys = Object.keys(paramValues) || []
    let objKeysLen = objKeys.length
    for(var j=0; j < objKeysLen; j++) {
      if(paramValues[objKeys[j]] === value) {
        newValue = objKeys[j]
        break
      }else{
        newValue = value
      }
    }
  }
  return newValue
}

/**
 * [translatePageType Translate pageType using pathSegments]
 * @param  {Object}   edition   edition data
 * @param  {String}   pageType  pageType value to be converted
 * @param  {Boolean}  localized localize to the current edition language
 * @return {String}             translated pageType
 */
export function translatePageType(edition={}, pageType, localized=true) {

  const pathSegments = selectn('uriRewrites.pathSegments', edition) || {}

  const path = [ '/', pageType, '/' ].join('')
  const translatedPath = translatePath(pathSegments, path, localized)
  const pathArr = translatedPath.split('/') || []
  const translatedPageType = (pathArr.length > 1) ? pathArr[1] : ''
  return translatedPageType
}



// WEBPACK FOOTER //
// ../app/lib/utils/translateURI.js